import React, { useEffect, useState } from "react";
import { Button, Input, Form, Select, Checkbox, Switch, Space } from "antd";
import { Link } from "react-router-dom";
import { ShowOTP } from "../ShowOTP/ShowOTP";
import ShowPack from "../ShowPack.js/ShowPack";
import axios from "axios";

const HeaderFlow = ({
  formSubmit,
  showPack,
  showOTP,
  OTPSubmit,
  packSubmit,
  ani,
  isFrench,
  setFrench,
}) => {
  const [number, setNumber] = useState(ani);
  const [evinaData, setEvinaData] = useState({ tid: '', ti: '', ts: '' }); // ✅ for Evina
  const [isBoxChecked, setiBoxChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const { Option } = Select;
  const [form] = Form.useForm();

  // ✅ Evina Integration
useEffect(() => {
   const loadEvinaScript = async () => {
      try {
        const response = await axios.get("/api/get-evina-script");
        console.log("[Evina] Script Loaded", response.data);
        const { s, tid, ti, ts } = response.data;

        const scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        scriptElement.innerHTML = response.data.s;
        document.head.appendChild(scriptElement);
        setEvinaData({ tid, ti, ts });
        const fireEvent = () => {
          const ev = new Event("DCBProtectRun");
          document.dispatchEvent(ev);
          console.log("[Evina] DCBProtectRun dispatched");
        };

        if (document.readyState === "complete" || document.readyState === "interactive") {
          fireEvent();
        } else {
          document.addEventListener("DOMContentLoaded", fireEvent);
        }

      } catch (error) {
        console.error("Failed to load Evina script", error);
      }
    };


  // const loadEvinaScript = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:30621/api/get-evina-script");
  //     console.log("[Evina] Script Loaded", response.data);
  //     const { s, tid, ti, ts } = response.data;

  //     // ✅ Register listener BEFORE dispatch
  //     document.addEventListener("DCBProtectRun", () => {
  //       console.log("[Evina] ✅ DCBProtectRun event received in React");
  //     });

  //     const scriptElement = document.createElement("script");
  //     scriptElement.type = "text/javascript";
  //     scriptElement.innerHTML = s;
  //     document.head.appendChild(scriptElement);

  //     console.log("[Evina] Script appended, dispatching DCBProtectRun");
  //     const ev = new Event("DCBProtectRun");
  //     document.dispatchEvent(ev);

  //     setEvinaData({ tid, ti, ts });

  //   } catch (error) {
  //     console.error("Failed to load Evina script", error);
  //   }
  // };

  loadEvinaScript();
}, []);


  console.log("EVINA SETTED",evinaData)

  return (
    <>
      <Space direction="vertical" style={{ padding: "20px" }}>
        <Switch
          checkedChildren="عربى"
          unCheckedChildren="française"
          defaultChecked
          onChange={(value) => {
            setFrench(value);
          }}
        />
      </Space>

      {showPack && !showOTP ? (
        <Form
          form={form}
          name="form-field"
          initialValues={{ remember: true }}
          onFinish={formSubmit}
          autoComplete="off"
        >
          <Form.Item
            name="msisdn"
            label={`${
              isFrench ? "Numero d'identification" : "إدخال رقم الهاتف المحمول"
            }`}
            rules={[{ required: true }]}
          >
            <Input
              value={number}
              placeholder={number}
              maxLength="12"
              size="large"
              readOnly
            />
          </Form.Item>
        </Form>
      ) : null}

      {showOTP && (
        <ShowOTP showOTP={showOTP} OTPSubmit={OTPSubmit} />
      )}

      {showPack && (
        <ShowPack
          packSubmit={packSubmit}
          isFrench={isFrench}
          evinaData={evinaData} 
          isBoxChecked={isBoxChecked}
        />
      )}

      <Checkbox
        onChange={(e) => setiBoxChecked(e.target.checked)}
        checked={isBoxChecked}
      >
        <Link to="/landing/toonflix/tnc">
          <h5>
            {isFrench
              ? "Accepter les termes et conditions"
              : "قبول الشروط والأحكام"}
          </h5>
        </Link>
      </Checkbox>

      {!isBoxChecked && (
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <h5 style={{ color: "red" }}>Please accept terms and conditions</h5>
        </Form.Item>
      )}
    </>
  );
};

export default HeaderFlow;






// import React, { useState } from "react";

// import { Button, Input, Form, Select, Checkbox, Switch, Space } from "antd";
// import { Link } from "react-router-dom";
// import { ShowOTP } from "../ShowOTP/ShowOTP";
// import ShowPack from "../ShowPack.js/ShowPack";

// const HeaderFlow = ({
//   formSubmit,
//   showPack,
//   showOTP,
//   OTPSubmit,
//   packSubmit,
//   ani,
//   isFrench,
//   setFrench,
// }) => {
//   const [number, setNumber] = useState(ani);
//   const [isBoxChecked, setiBoxChecked] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const { Option } = Select;
//   const [form] = Form.useForm();
//   console.log("HEDER FLOW ", ani);


//   return (
//     <>
//       <Space direction="vertical" style={{ padding: "20px" }}>
//         <Switch
//           checkedChildren="عربى"
//           unCheckedChildren="française"
//           defaultChecked
//           onChange={(value) => {
//             console.log(value);
//             setFrench(value);
//           }}
//         />
//       </Space>
//       {showPack && !showOTP ? (
//         <Form
//           form={form}
//           name="form-field"
//           initialValues={{
//             remember: true,
//           }}
//           // onFinish={onFinishOTP}
//           onFinish={formSubmit}
//           autoComplete="off"
//         >
//           <Form.Item
//             name="msisdn"
//             label={`${
//               isFrench ? "Numero d'identification" : "إدخال رقم الهاتف المحمول"
//             }`}
//             rules={[
//               {
//                 required: true,
//               },
//             ]}
//           >
//             <Input
//               // style={{ width: "70%" }}
//               value={number}
//               placeholder={number}
//               maxLength="12"
//               size="large"
//               readOnly

//               // onChange={(e) => setNumber(e.target.value)}
//             />
//           </Form.Item>
//           {/* <Button
//             className="custom-button"
//             size="large"
//             type="primary"
//             htmlType="submit"
//             // onClick={formSubmit}
//             // style={{ textAlign: "center" }}
//           >
//             Subscribe
//           </Button> */}
//         </Form>
//       ) : null}

//       {showOTP ? <ShowOTP showOTP={showOTP} OTPSubmit={OTPSubmit} /> : null}
//       {showPack ? (
//         <ShowPack packSubmit={packSubmit} isFrench={isFrench} />
//       ) : null}
//       <Checkbox
//         onChange={(e) => {
//           setiBoxChecked(e.target.checked);

//           // console.log(e.target.checked);
//         }}
//         checked={isBoxChecked}
//       >
//         {" "}
//         <Link to="/landing/toonflix/tnc">
//           {/* Accepter les termes et conditions */}
//           <h5>
//             {isFrench
//               ? "Accepter les termes et conditions"
//               : "قبول الشروط والأحكام"}
//             {/* {`${
//                     isFrench ? (
//                       <h5>Accepter les termes et conditions</h5>
//                     ) : (
//                       "قبول الشروط والأحكام"
//                     )
//                   }`} */}
//           </h5>
//           {/* {`${isFrench ?  <h5>Accepter les termes et conditions</h5> : "قبول الشروط والأحكام"}`} */}
//         </Link>
//       </Checkbox>
//       {/* </Form.Item> */}
//       {!isBoxChecked && (
//         <Form.Item
//           wrapperCol={{
//             offset: 8,
//             span: 16,
//           }}
//         >
//           <h5 style={{ color: "red" }}>Please accept terms and conditions</h5>
//         </Form.Item>
//       )}
//     </>
//   );
// };

// export default HeaderFlow;
